import React from 'react';
import logo from '../../asset/images/logo.png';
const LoaderOpening = () => {
  return (
    <div className="w-full flex justify-center items-center">
      <img
        className="h-24 lg:h-32 w-24 lg:w-32 animate-pulse text-[#64feda]"
        src={logo}
        alt=""
      />
    </div>
  );
};

export default LoaderOpening;
